import { render, staticRenderFns } from "./ProductivityHistory.vue?vue&type=template&id=0392d98f"
import script from "./ProductivityHistory.vue?vue&type=script&lang=js"
export * from "./ProductivityHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports